module.exports = __webpack_public_path__ + "static/media/ic-chevron-right-grey.f6efdd98.svg";